import { AxiosResponse } from 'axios';

import api from '~/services/api';

class ConfigurationService {
  getConfiguration(): Promise<AxiosResponse<any>> {
    return api.get<any>('/common/configuration');
  }

  saveConfiguration(payload: any) {
    return api.post<any>('/common/configuration', payload);
  }

  postShipping(file: File) {
    const formData = new FormData();
    formData.append('shipping', file);
    return api.post('/domain/shipping', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  getPix() {
    return api.get('/payment/pix-config');
  }

  savePix(payload: any) {
    return api.post('/payment/pix-config', payload);
  }

  deletePix(payload: { _id: string }) {
    return api.delete('/payment/pix-config', {
      data: payload
    });
  }

  editPix(payload) {
    return api.put(`/payment/pix-config`, payload);
  }
}

export default new ConfigurationService();
